/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const HappyFaceIcon = ({size, ...props}) => (
  <svg viewBox="0 0 58 58" fill="currentColor" width={ size || "58" } height={ size || "58" } {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" stroke="#0059FF" d="M27-1c7.732 0 14.732 3.134 19.799 8.201S55 19.268 55 27c0 7.732-3.134 14.732-8.201 19.799S34.732 55 27 55c-7.732 0-14.732-3.134-19.799-8.201S-1 34.732-1 27c0-7.732 3.134-14.732 8.201-19.799S19.268-1 27-1z"
        transform="translate(2 2)" strokeWidth="2" />
      <path fill="#0059FF" d="M38 33.14C36.57 38.255 31.966 42 26.506 42 21.03 42 16.416 38.235 15 33.098c1.904-.552-1.953.548 1.886-.546.95 3.417 4.127 7.372 9.62 7.372 5.493 0 8.643-3.953 9.59-7.372 1.342.406-1.923-.548 1.904.588zM37 20c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zM18 20c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z"
        transform="translate(2 2)" />
    </g>
  </svg>
);
HappyFaceIcon.displayName = 'HappyFaceIcon';
HappyFaceIcon.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
